import { createSlice } from '@reduxjs/toolkit';
import { createAppAsyncThunk } from '../withTypes';
import { Status, STATUSES } from '@/types/store';
import { Language, Role } from '@/graphql/types';
import { fetchInitialData } from '@/api/users';
import { errorMessages } from '@/utils/errorMessages';
import { showToast } from '@/utils/utils';

export interface UsersState {
  roles: Role[];
  languages: Language[];
  status: Status;
}

const initialState: UsersState = {
  roles: [],
  languages: [],
  status: STATUSES.IDLE,
};

/* THUNKS */
export const fetchBaseData = createAppAsyncThunk(
  'users/baseData',
  async () => {
    return await fetchInitialData();
  },
);

export const userReducer = createSlice({
  name: 'user',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBaseData.pending, (state) => {
      state.status = STATUSES.PENDING;
    });
    builder.addCase(fetchBaseData.fulfilled, (state, action) => {
      state.roles = action.payload.roles;
      state.languages = action.payload.languages;
      state.status = STATUSES.FULFILLED;
    });
    builder.addCase(fetchBaseData.rejected, (state) => {
      state.roles = initialState.roles;
      state.languages = initialState.languages;
      showToast(errorMessages.fetchingUserData, 'error');
    });
  },
});

export default userReducer.reducer;
